import clsx from "clsx";
import { FC, PropsWithChildren } from "react";
import styles from "./sample-header.module.scss";

type Props = {
  className?: string;
  classification?: string;
};

const SampleHeader: FC<PropsWithChildren<Props>> = ({
  children,
  classification = "unknown",
  className
}) => (
  <header
    className={clsx(styles.header, styles[`${classification}`], className)}
  >
    {children}
  </header>
);

export default SampleHeader;
